<template>
  <div class="login-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <div class="card">
      <div class="card-top">
        <div class="brand-icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="14" stroke="#2dd4bf" stroke-width="2" opacity="0.3" />
            <circle cx="16" cy="16" r="8" stroke="#2dd4bf" stroke-width="2" />
            <circle cx="16" cy="16" r="3" fill="#2dd4bf" />
          </svg>
        </div>
        <h1 class="brand-name">酷度物联网</h1>
        <p class="brand-desc">智能硬件管理平台</p>
      </div>

      <h2 class="form-title">欢迎回来</h2>

      <div class="form-body">
        <div class="input-group">
          <label class="input-label">手机号</label>
          <div class="input-wrap">
            <van-field v-model="userphone" clearable placeholder="请输入手机号" input-class="field-input" maxlength="11" />
          </div>
        </div>

        <div class="input-group">
          <label class="input-label">密码</label>
          <div class="input-wrap">
            <van-field v-model="userpassword" :type="showPwd ? 'text' : 'password'" clearable placeholder="请输入密码"
              input-class="field-input" :right-icon="showPwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="showPwd = !showPwd" />
          </div>
        </div>
      </div>

      <button class="submit-btn" @click="login" :disabled="loading">
        <span v-if="!loading">登 录</span>
        <span v-else class="btn-loading"></span>
      </button>

      <div class="links">
        <span @click="gotoregister">新用户注册</span>
        <span @click="gotoreset">忘记密码</span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "login",
  data() {
    return {
      userphone: "",
      userpassword: "",
      showPwd: false,
      loading: false,
      wcxlink: this.$route.query.wcxlink,
      openid: this.$store.state.openid || this.$route.query.openid || ""
    };
  },
  methods: {
    gotoregister() {
      this.$router.push({
        name: "register",
        query: {
          wcxlink: this.wcxlink
        }
      });
    },
    gotoreset() {
      this.$router.push({
        name: "passwordreset",
        query: {
          wcxlink: this.wcxlink
        }
      });
    },
    login() {
      if (!this.userphone || !this.userpassword) {
        this.$toast.fail("请填写完整信息");
        return;
      }
      this.loading = true;
      const qs = require("qs");
      this.$axios
        .post(
          "/api/user/login",
          qs.stringify({
            phone: this.userphone,
            password: this.userpassword,
            wcxlink: this.wcxlink,
            openid: this.openid
          })
        )
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {

            console.log(wx.miniProgram)

            this.$store.commit("set_is_login", true);
            // 回到小程序首页，重新登录，避免没有session['user'] 绑定设备异常
            //if (typeof wx !== 'undefined' && wx.miniProgram) 
            if (this.$store.state.is_xcx) {
              console.log("wxxcx")
              wx.miniProgram.navigateTo({
                url: '/pages/login/login'
              });
            }
            else {
              this.$router.push({
                path: "/",
                name: "设备主页",
                query: {
                  gid: [""]
                }
              });
            }


          } else {
            this.$store.commit("set_is_login", false);
            this.$toast.fail("登录失败,账户或密码错误！");
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>

<style scoped>
.login-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 40%, #f0fdf4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  font-family: "Inter", "Noto Sans SC", sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.12) 0%, transparent 70%);
  top: -80px;
  right: -60px;
  animation: shapeDrift 20s ease-in-out infinite alternate;
}

.shape-2 {
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(251, 113, 133, 0.08) 0%, transparent 70%);
  bottom: -40px;
  left: -80px;
  animation: shapeDrift 18s ease-in-out infinite alternate-reverse;
}

.shape-3 {
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(167, 139, 250, 0.07) 0%, transparent 70%);
  top: 30%;
  left: -40px;
  animation: shapeDrift 22s ease-in-out infinite alternate;
}

.shape-4 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.06) 0%, transparent 70%);
  bottom: 20%;
  right: -50px;
  animation: shapeDrift 16s ease-in-out infinite alternate-reverse;
}

@keyframes shapeDrift {
  0% {
    transform: translate(0, 0) scale(1);
  }

  100% {
    transform: translate(30px, -20px) scale(1.1);
  }
}

.card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 28px;
  padding: 40px 32px 36px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.04), 0 20px 60px rgba(0, 0, 0, 0.06);
  animation: cardSlide 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes cardSlide {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-top {
  text-align: center;
  margin-bottom: 28px;
}

.brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.brand-name {
  font-weight: 700;
  font-size: 24px;
  color: #1e293b;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.brand-desc {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.form-title {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  margin: 0 0 24px;
  letter-spacing: 1px;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 28px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  padding-left: 2px;
}

.input-wrap :deep(.van-cell) {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px 16px;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
  min-height: 48px;
}

.input-wrap :deep(.van-cell:focus-within) {
  border-color: #2dd4bf;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(45, 212, 191, 0.08);
}

.input-wrap :deep(.van-field__body) {
  background: transparent;
}

.field-input {
  color: #1e293b !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: transparent !important;
}

.input-wrap :deep(.van-field__placeholder) {
  color: #cbd5e1 !important;
  font-weight: 400 !important;
}

.input-wrap :deep(.van-field__right-icon) {
  color: #94a3b8;
  font-size: 18px;
}

.input-wrap :deep(.van-field__clear) {
  color: #cbd5e1;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);
  box-shadow: 0 4px 16px rgba(45, 212, 191, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 20px;
  font-family: inherit;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.97);
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.links {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
}

.links span {
  font-size: 14px;
  color: #2dd4bf;
  cursor: pointer;
  transition: color 0.2s;
  font-weight: 500;
}

.links span:active {
  color: #0d9488;
}
</style>